// Конструктор (README §4). Полотно грузится лениво (React.lazy), меню — сразу:
// «Схемы», «Улучшения» (§4.5, Improve.tsx), лампочка с бейджем в полосе 56.

import { lazy, useEffect, useState } from 'react'
import { RailButton } from '../../ui/RailButton'
import { SideMenu } from '../../ui/SideMenu'
import type { SideItem } from '../../ui/SideMenu'
import type { SectionModule } from '../types'
import { ImproveBlock, useSuggestionCount } from './Improve'
import { useFlowStore } from './store'

const View = lazy(() => import('./FlowView'))

function RenameInput({ id, title, done }: { id: string; title: string; done(): void }) {
  const [v, setV] = useState(title)
  const commit = () => {
    if (v.trim() && v.trim() !== title) void useFlowStore.getState().renameScheme(id, v)
    done()
  }
  return (
    <input
      className="fl-rename"
      value={v}
      autoFocus
      onFocus={(e) => e.currentTarget.select()}
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => setV(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        e.stopPropagation()
        if (e.key === 'Enter') commit()
        if (e.key === 'Escape') done()
      }}
    />
  )
}

function Sidebar() {
  const schemes = useFlowStore((s) => s.schemes)
  const schemeId = useFlowStore((s) => s.schemeId)
  const [renaming, setRenaming] = useState<string | null>(null)

  useEffect(() => {
    if (!useFlowStore.getState().schemes.length) void useFlowStore.getState().loadSchemes()
  }, [])

  // новая схема сразу открывается с полем названия — вбить своё прямо в меню
  const add = () => {
    void useFlowStore.getState().createScheme('новая схема').then(() => {
      setRenaming(useFlowStore.getState().schemeId)
    })
  }
  const items: SideItem[] = schemes.map((x) => ({
    id: x.id,
    label: renaming === x.id
      ? <RenameInput id={x.id} title={x.title} done={() => setRenaming(null)} />
      : x.title,
    meta: String(x.nodes),
    active: x.id === schemeId,
    keepOpen: x.id === schemeId,
    title: x.id === schemeId ? 'нажмите, чтобы переименовать' : 'открыть схему',
    // клик по открытой схеме — переименовать на месте, по другой — открыть её
    onSelect: () => {
      if (renaming === x.id) return
      if (x.id === schemeId) setRenaming(x.id)
      else void useFlowStore.getState().openScheme(x.id)
    },
  }))
  items.push({ id: 'add', label: '+ схема', action: true, keepOpen: true, onSelect: add })

  return (
    <SideMenu
      screen="flow"
      sections={[
        { id: 'schemes', title: 'Схемы', count: schemes.length || undefined, onAdd: add, addTitle: 'новая схема', items },
      ]}
    >
      <ImproveBlock />
    </SideMenu>
  )
}

function RailExtra({ expand }: { expand: () => void }) {
  const n = useSuggestionCount()
  return <RailButton icon="bulb" title={n ? `улучшения · ${n}` : 'улучшения'} badge={n || undefined} onClick={expand} />
}

const flow: SectionModule = {
  Sidebar,
  View,
  RailExtra,
  useRail: () => {
    const n = useFlowStore((s) => s.schemes.length)
    return { count: n ? String(n) : undefined, tip: 'схемы' }
  },
}
export default flow
